/* eslint-disable no-plusplus */
/* eslint-disable @typescript-eslint/no-loop-func */
/* eslint-disable react/no-array-index-key */
/* eslint-disable function-paren-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-return-assign */
/* eslint-disable operator-linebreak */
/* eslint-disable react/no-unused-prop-types */
import React, { useEffect, useRef, useState, useCallback } from 'react';
import { decode } from 'html-entities';
import { Text, Group } from 'react-konva';
import html from 'html-parse-stringify';
import Konva from 'konva';
import { Line as LineType, Phrase } from '../types';

type Word = {
  text: string;
  phrase: Phrase;
  fontStyle: string;
  fontSize: number;
  fill: string;
  x: number;
  y: number;
};

type Props = LineType & {
  position: number;
  yPosition: number;
  highlightedPhrases: Phrase[];
  onClick: (phrase: Phrase) => void;
  onDblClick: (phrase: Phrase) => void;
  isPlaying: boolean;
  infoName: string;
  plainTextView: boolean;
  fontFamily: string;
  fontSize: number;
  textPrimaryColor: string;
  textHighlightColor: string;
  totalLineCount: number;
  highlightInfoName: boolean;
  longestInfoNameLength: number;
  containerWidth?: number;
  onHeightChange: (lineId: string, height: number) => void;
  onLineFlagsChange?: (
    lineId: string,
    flags: { hasLarge: boolean; hasOnlySmall: boolean }
  ) => void;
};

const Line = ({
  id,
  yPosition,
  phrases,
  highlightedPhrases,
  onClick,
  onDblClick,
  isPlaying,
  infoName,
  position,
  fontFamily,
  fontSize,
  textPrimaryColor,
  textHighlightColor,
  plainTextView,
  totalLineCount,
  highlightInfoName,
  longestInfoNameLength,
  containerWidth = 1023.65,
  onHeightChange,
  onLineFlagsChange,
}: Props): JSX.Element => {
  const doubleClick = useRef<NodeJS.Timeout | null>(null);
  const infoNameRef = useRef<Konva.Text>(null);
  const itemEls = useRef<{ [phraseId: number]: Konva.Text[] }>({});
  const groupRef = useRef<Konva.Group>(null);
  const [positionedWords, setPositionedWords] = useState<Word[]>([]);
  const [infoNameYOffset, setInfoNameYOffset] = useState<number>(0);

  const handleFill = useCallback(
    (phrase: Phrase) => {
      const isHighlitablePhrase = highlightedPhrases.some(
        (phraseItem: Phrase) => phraseItem.id === phrase.id
      );

      const fillColour =
        isHighlitablePhrase && phrase.isHighlightable && isPlaying
          ? textHighlightColor
          : textPrimaryColor;
      return fillColour;
    },
    [highlightedPhrases, isPlaying, textHighlightColor, textPrimaryColor]
  );

  const scaleFont = (value: number) => value / 1.05;

  useEffect(() => {
    if (groupRef.current) {
      const height = groupRef.current.getClientRect({
        skipTransform: true,
      }).height;
      onHeightChange(id.toString(), height);
    }
  }); // Run on every render to report height

  useEffect(() => {
    // 1. Flatten phrases and HTML into a single list of word objects
    const words: Omit<Word, 'x' | 'y'>[] = [];
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    if (!context) return;

    let foundLarge = false;
    let hasSmallText = false;
    let hasNonSmallText = false;

    phrases.forEach((phrase) => {
      const parsed = html.parse(decode(phrase.content));

      const traverse = (
        nodes: any[],
        currentStyle: any,
        underSmall = false
      ) => {
        nodes.forEach((node) => {
          if (node.type === 'text' && node.content) {
            node.content.split(' ').forEach((wordText: string) => {
              if (wordText) {
                words.push({
                  text: wordText,
                  phrase,
                  ...currentStyle,
                });
                if (underSmall) {
                  hasSmallText = true;
                } else {
                  hasNonSmallText = true;
                }
              }
            });
          } else if (node.type === 'tag' && node.children) {
            const newStyle = { ...currentStyle };
            if (node.name === 'large') {
              if (!plainTextView) {
                newStyle.fontSize = scaleFont(fontSize + 16);
                foundLarge = true;
              }
            }
            if (node.name === 'small') {
              newStyle.fontSize = scaleFont(fontSize / 1.6);
            }
            if (node.name === 'italic' || node.name === 'bold') {
              newStyle.fontStyle = `${currentStyle.fontStyle || ''} ${
                node.name
              }`.trim();
            }
            traverse(
              node.children,
              newStyle,
              underSmall || node.name === 'small'
            );
          }
        });
      };

      const initialStyle = {
        fill: handleFill(phrase),
        fontFamily,
        fontSize: scaleFont(fontSize),
        fontStyle: '',
      };
      traverse(parsed, initialStyle, false);
    });

    // Report tag flags upward (hasLarge)
    if (onLineFlagsChange) {
      const hasOnlySmall = hasSmallText && !hasNonSmallText;
      onLineFlagsChange(id.toString(), { hasLarge: foundLarge, hasOnlySmall });
    }

    // 2. Calculate positions for each word using per-line baseline alignment
    type MeasuredWord = Omit<Word, 'x' | 'y'> & {
      wordWidth: number;
      spaceWidth: number;
      ascent: number;
      descent: number;
    };
    const measuredWords: MeasuredWord[] = words.map((w) => {
      context.font = `${w.fontStyle} ${w.fontSize}px ${fontFamily}`;
      // Measure widths separately to avoid counting trailing space in wrap fit
      const wordWidth = context.measureText(`${w.text}`).width;
      const spaceWidth = context.measureText(' ').width;
      // Measure ascent/descent using a sample string that includes descenders
      const sample = 'Mgypq';
      const sampleMetrics = context.measureText(sample);
      const ascent =
        (sampleMetrics as any).actualBoundingBoxAscent ||
        Math.ceil(w.fontSize * 0.78);
      const descent =
        (sampleMetrics as any).actualBoundingBoxDescent ||
        Math.ceil(w.fontSize * 0.22);
      return {
        ...w,
        wordWidth,
        spaceWidth,
        ascent,
        descent,
      };
    });

    const xOffset = totalLineCount > 10 ? 162 : 190;
    let baseX = 60.54;
    if (infoName && infoName.length > 3) baseX = xOffset;
    if (longestInfoNameLength > 10) baseX = longestInfoNameLength * 20;

    const rightMargin = 60;
    const availableWidth = Math.max(0, containerWidth - baseX - 12);
    const wrapTolerance = 10; // allow small overflow to fit one more word

    const linesBuf: {
      words: MeasuredWord[];
      maxAscent: number;
      maxDescent: number;
      height: number;
    }[] = [];

    let lineWords: MeasuredWord[] = [];
    let lineMaxAscent = 0;
    let lineMaxDescent = 0;
    let cursorX = baseX;

    const flushLine = () => {
      if (!lineWords.length) return;
      const height = Math.ceil(lineMaxAscent + lineMaxDescent);
      linesBuf.push({
        words: lineWords,
        maxAscent: lineMaxAscent,
        maxDescent: lineMaxDescent,
        height,
      });
      lineWords = [];
      lineMaxAscent = 0;
      lineMaxDescent = 0;
      cursorX = baseX;
    };

    measuredWords.forEach((mw) => {
      // Wrap if this word doesn't fit within the available width (from baseX)
      const usedWidthOnLine = cursorX - baseX;
      if (
        usedWidthOnLine + mw.wordWidth > availableWidth + wrapTolerance &&
        lineWords.length
      ) {
        flushLine();
      }

      lineWords.push(mw);
      lineMaxAscent = Math.max(lineMaxAscent, mw.ascent);
      lineMaxDescent = Math.max(lineMaxDescent, mw.descent);
      cursorX += mw.wordWidth + mw.spaceWidth;
    });
    // Flush the last line
    flushLine();

    // 3. Convert to positioned words using baseline alignment
    const positioned: Word[] = [];
    let topY = 0;
    const intraLineGap = plainTextView ? 4 : 6; // smaller, consistent gap between wrapped lines
    const baselineMin = Math.ceil(
      scaleFont(fontSize) + (plainTextView ? 0 : 4)
    );
    linesBuf.forEach((ln) => {
      let x = baseX;
      ln.words.forEach((mw) => {
        const y = topY + (ln.maxAscent - mw.ascent); // align on baseline
        positioned.push({
          text: mw.text,
          phrase: mw.phrase,
          fontStyle: mw.fontStyle,
          fontSize: mw.fontSize,
          fill: mw.fill,
          x,
          y,
        });
        x += mw.wordWidth + mw.spaceWidth;
      });
      const step = Math.max(
        baselineMin,
        Math.ceil(ln.maxAscent + ln.maxDescent)
      );
      topY += step + intraLineGap;
    });

    // Align infoName to the first line's baseline
    if (infoName && linesBuf.length > 0) {
      const firstLineAscent = linesBuf[0].maxAscent;
      context.font = `${''} ${fontSize}px ${fontFamily}`;
      const sample = 'Mgypq';
      const sampleMetrics = context.measureText(sample);
      const infoAscent =
        (sampleMetrics as any).actualBoundingBoxAscent ||
        Math.ceil(fontSize * 0.78);
      setInfoNameYOffset(firstLineAscent - infoAscent);
    } else {
      setInfoNameYOffset(0);
    }

    setPositionedWords(positioned);
  }, [
    phrases,
    containerWidth,
    fontSize,
    fontFamily,
    handleFill,
    infoName,
    longestInfoNameLength,
    totalLineCount,
    plainTextView,
  ]);

  const getClickHandler = (phrase: Phrase) => {
    // doubleClick.current is null
    // if user hasn't done a first click or if user completes a doubleclick
    if (!doubleClick.current) {
      // global.setTimeout tells typescript *not* node.setTimeout (different return types)
      doubleClick.current = global.setTimeout(() => {
        // Cancellable timeout allows user to initiate double click
        onClick(phrase);
        doubleClick.current = null;
      }, 250);
    } else {
      // if user double clicks this will enter
      clearTimeout(doubleClick.current);
      doubleClick.current = null;
      onDblClick(phrase);
    }
  };

  const setCursorType = (isClickable: boolean) => {
    document.body.style.cursor = isClickable ? 'pointer' : 'default';
  };

  return (
    <Group ref={groupRef} y={yPosition}>
      {!!infoName && position === 0 && (
        <Text
          x={16}
          y={infoNameYOffset}
          text={infoName}
          fill={highlightInfoName ? textHighlightColor : textPrimaryColor}
          fontFamily={fontFamily}
          fontSize={scaleFont(fontSize)}
          ref={infoNameRef}
        />
      )}
      {positionedWords.map((word, index) => (
        <Text
          key={`${word.text}-${index}`}
          x={word.x}
          y={word.y}
          text={word.text}
          fill={word.fill}
          fontFamily={fontFamily}
          fontSize={word.fontSize}
          fontStyle={word.fontStyle}
          onMouseEnter={() => setCursorType(word.phrase.isClickable)}
          onMouseLeave={() => (document.body.style.cursor = 'default')}
          onMouseDown={(e) => {
            if (e.evt.button !== 0 || !word.phrase.isClickable) return;
            getClickHandler(word.phrase);
          }}
        />
      ))}
    </Group>
  );
};

export default Line;
